import React from 'react'
import DraftDevicesMethods from './draftDevices.local.methods'
import DraftDevicesToolbar from './__toolbar/draftDevices__toolbar'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { cn } from 'ethcss'
import translate from 'core/translate'
import styles from './draftDevices.jcss'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import Modal from 'blocks.simple/modal/modal'
import { DraftDeviceInformation } from './DraftDeviceInformation'
import { draftDevicesActions } from './draftDevice.state'
import { checkAvailableModule } from '../../core/helpers/routes/routes'
import Button from 'blocks.simple/button/button'
import { Typography } from 'atoms/Typography'
import { colors, grid, item, text } from 'theme'
import helpersDisplays from 'core/helpers/_digitalSignages'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import Icon from 'blocks.simple/icon/icon'

const DraftDevices = () => {
    const {
        selectedInfo,
        selectedItems,
        setSelectedInfo,
        setSelectedItems,
        openRegisterModal,
        setOpenRegisterModal,
        currentLicense,
        setCurrentLicense,
        licensesData,
        isLicenseNull,
        selectedFolderId,
        folders,
        onChangeFolder,
        registerDevices,
        setIsLicenseNull,
        checkEmptyLicences,
    } = DraftDevicesMethods()
    const dispatch = useDispatch()
    const draftDevices: any = useSelector<RootStateOrAny>((state) => state.draftDevices)

    const closeModal = () => {
        dispatch(draftDevicesActions.closeModal())
    }

    const renderModalContent = (modalState: string) => {
        if (!modalState) return null

        switch (modalState) {
            case 'information':
                return <DraftDeviceInformation device={selectedInfo} />
            default:
                return null
        }
    }

    const checkDeviceCountAndFreeLicenceCount = () => {
        if (currentLicense.vacantCount) {
            if (selectedItems && selectedItems.length > 0) {
                return selectedItems.length <= currentLicense.vacantCount
            } else {
                return [selectedInfo].length <= currentLicense.vacantCount
            }
        } else {
            return false
        }
    }

    return (
        <Content
            title={translate('draftDevices')}
            toolbar={
                <DraftDevicesToolbar
                    currentLicense={currentLicense}
                    selectedInfo={selectedInfo}
                    selectedItems={selectedItems}
                    onChange={(selectedItems: { id: number }[]) => setSelectedItems(selectedItems)}
                    openRegisterModal={openRegisterModal}
                    setOpenRegisterModal={setOpenRegisterModal}
                />
            }
        >
            <Catalog
                type={'draftDevices'}
                key={'draftDevices__catalog'}
                selectedInfo={selectedInfo}
                onSelectInfo={(
                    selectedInfo: {
                        id: number
                        name: string
                        status: string
                    } | null
                ) => setSelectedInfo(selectedInfo)}
                breadcrumbsClassName={cn(styles.breadcrumbs)}
                selectedItems={selectedItems}
                onSelect={(selectedItems: any) => setSelectedItems(selectedItems)}
                treeView={false}
            />
            <Modal open={draftDevices.modalState} onClose={closeModal} {...draftDevices.modalOptions}>
                {renderModalContent(draftDevices.modalState)}
            </Modal>
            <Modal mod="clear" open={openRegisterModal} onClose={() => setOpenRegisterModal(false)}>
                <div className={cn(grid.full, grid.rowCenter, item.blackOpacity)}>
                    <div className={cn(item.whereUseCard, item.shadowModal, item.rounded_full_mini, styles.width)}>
                        <div className={cn(grid.col, grid.mb_md)}>
                            <div className={cn(grid.row, grid.center)}>
                                <Typography className={cn(grid.mb_md, text.bold, text.center)}>
                                    {translate('registerDevice')}
                                </Typography>
                            </div>
                            {helpersDisplays.isCheckLicenseQ() && (
                                <div className={cn(grid.mb_md, grid.mt_big, item.rel)}>
                                    <Dropdown
                                        id="openRegisterModal"
                                        label={
                                            <Typography
                                                type="title"
                                                className={cn(
                                                    text.up,
                                                    text.centerBlock,
                                                    text['normalPlus'],
                                                    grid.mb_mini
                                                )}
                                            >
                                                {translate('licensesType')}
                                            </Typography>
                                        }
                                        centered
                                        placeholder={translate('select')}
                                        value={currentLicense.id && currentLicense.id}
                                        options={licensesData}
                                        onChange={(selected) => {
                                            setIsLicenseNull(false)
                                            setCurrentLicense(selected)
                                        }}
                                    />
                                    {currentLicense?.vacantCount ? (
                                        <div className={cn(styles.license__info, grid.pt_mini, text.center)}>
                                            <Typography type="text">
                                                {translate('licensesBalance')} {currentLicense.vacantCount}{' '}
                                                {translate('licensesLeft')}
                                            </Typography>
                                        </div>
                                    ) : currentLicense?.vacantCount === 0 && checkEmptyLicences(licensesData) ? (
                                        <div className={cn(styles.noLicensesLeft, text.center, grid.pt_mini)}>
                                            <Icon type={'info'} color={colors.notificationRed} />
                                            <span>{translate('noLicencesInTariff')}</span>
                                        </div>
                                    ) : null}
                                    {!checkEmptyLicences(licensesData) && (
                                        <div className={cn(styles.noLicensesLeft, text.center, grid.pt_mini)}>
                                            <Icon type={'info'} color={colors.notificationRed} />
                                            <span>{translate('noLicencesInTariffs')}</span>
                                        </div>
                                    )}
                                    {isLicenseNull && (
                                        <div className={cn(text.center, grid.mt_md)}>
                                            <Typography type="title">{translate('fieldIsRequired')}</Typography>
                                        </div>
                                    )}
                                    {!checkDeviceCountAndFreeLicenceCount() && currentLicense.id && currentLicense.id && (
                                        <div className={cn(styles.license__info, grid.pt_mini, text.center)}>
                                            <Typography type="text">{translate('licenceDeviceCheck')}</Typography>
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className={cn(item.rel)}>
                                <Dropdown
                                    value={selectedFolderId}
                                    options={folders}
                                    placeholder={translate('select')}
                                    label={
                                        <Typography
                                            type="title"
                                            className={cn(text.up, text.centerBlock, text['normalPlus'], grid.mb_mini)}
                                        >
                                            {translate('chooseFolder')}
                                        </Typography>
                                    }
                                    onChange={onChangeFolder}
                                />
                            </div>
                        </div>
                        <Button
                            mod="fill"
                            disabled={helpersDisplays.isCheckLicenseQ() && !checkDeviceCountAndFreeLicenceCount()}
                            onClick={registerDevices}
                        >
                            {translate('register')}
                        </Button>
                        <Button
                            className={cn(grid.mt_md, item.rel)}
                            onClick={() => setOpenRegisterModal(false)}
                            mod="withBorder"
                        >
                            {translate('cancel')}
                        </Button>
                    </div>
                </div>
            </Modal>
        </Content>
    )
}

const exportDraftDevices = checkAvailableModule('displays/draftDevices') ? DraftDevices : null

export default exportDraftDevices
